import { Orders } from 'components/Protected'

export function OrdersPage() {
  return (
    <div>
      <Orders />
    </div>
  )
}
